module.exports = __webpack_public_path__ + "static/media/rps1.76a9b96c.png";